import React from 'react';
import { Exact, FeedPostsQuery, useCheckNewPostsQuery } from 'api';
import NewPrompt from 'components/NewPrompt';
import { ApolloQueryResult, useApolloClient } from '@apollo/client';

interface NewPostPromptProps {
    refetch: (variables?: Partial<Exact<{
        limit: number;
        offset: number;
    }>> | undefined) => Promise<ApolloQueryResult<FeedPostsQuery>>;
    date: string | undefined;
}
const NewPostPrompt: React.FC<NewPostPromptProps> = ({ refetch, date }) => {
    const { cache } = useApolloClient();
    const { data } = useCheckNewPostsQuery({
        variables: { date },
        pollInterval: 1000 * 60
    });

    const handleNewPostClick = () => {
        cache.modify({
            fields: {
                checkNewPosts: () => false
            }
        })
        refetch()
    }

    if (data?.checkNewPosts)
        return <NewPrompt title={"New posts"} handleClick={handleNewPostClick} topFixValue={100} />
    return null
}

export default NewPostPrompt;
